var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-plot-footer-wrapper"},[_c('asc-plot-footer',{attrs:{"page-plot":_vm.pagePlot,"mini-plot":_vm.miniPlot,"editable":_vm.editable,"on-update-caption":_vm.onUpdateCaption,"on-expand":_vm.onExpand}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }